import { GetWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Get')
export class GetNodeConnectorProvider extends ConnectorProvider<GetWorkflowNode> {}
